import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleEnum } from '../decorators/api-module.decorator';

/**
 * Prefixes all requests with `environment.serverUrl`.
 */

// @dynamic
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  static module: ModuleEnum;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // let _module: ModuleEnum =  Object.assign({}, ApiPrefixInterceptor.module;

    if (request.url.match("(./assets)")) {
      return next.handle(request);
    }
    if (request.url.includes("http")) {
      // const body = request.body;
      // this.convertToIso(body);

      request = request.clone({ url: request.url });
    } else {
      let serverUrl = environment.serverUrl;
     

      // switch (_module) {
      //   case ModuleEnum.GAD:
      //     serverUrl = environment.serverUrl;
      //   case ModuleEnum.MASTER_DATA:
      //     serverUrl = environment.serverUrlMD;
      // }

      request = request.clone({ url: serverUrl + request.url });
    }
    return next.handle(request);
  }

  
  convertToIso(body){
    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isValidDate(value)) {
        body[key] = new Date(value).getTime();
      } else if (typeof value === 'object') {
        this.convertToIso(value);
      }
    }
  }

   isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }

  isDate(value) {
    var re = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
    var flag = re.test(value);
    return flag;
  }

}
